 import axios from 'redaxios'
 import { defaultSearchParams } from 'config/search'
 import { useQuery } from 'react-query'
 import { HOW_TO } from 'utils/createURL'
 import { NEVER_NULL_TAG, APP_STUDIO_TAG, FUSION_AI_TAG, FUSION_CONNECTORS_TAG, FUSION_SERVER_TAG, FUSION_TAG, SPRINGBOARD_TAG, LUCIDWORKS_PLATFORM_TAG} from 'config/productItems';

 
 export default function useSearch(searchParams, base, currentProduct) {

    return useQuery(
        [`searchResults`, searchParams, base],
        () => {
          let searchUrl
          if(base === HOW_TO){
            searchUrl = defaultSearchParams.fusionHowToUrl + searchParams
          } else if (base === 'typeahead') {
            searchUrl = defaultSearchParams.fusionTypeaheadSuggestionsUrl + searchParams;
            switch(currentProduct.tag){
              case NEVER_NULL_TAG:
                searchUrl += `&fq=productName:("${currentProduct.tag}")`
                break;
              case SPRINGBOARD_TAG:
              case LUCIDWORKS_PLATFORM_TAG: 
                searchUrl += `&fq=productName:("${currentProduct.tag}")&fq=appType:("${currentProduct.value.replace(' ', '-')}")`
                break;
              case FUSION_TAG:
                searchUrl += `&fq=productName:("${currentProduct.tag}","${FUSION_CONNECTORS_TAG}")&fq=productVersion:("${currentProduct.label}")`
                break;
              case FUSION_SERVER_TAG:
                searchUrl += `&fq=productName:("${currentProduct.tag}","${FUSION_CONNECTORS_TAG}","${FUSION_AI_TAG}","${APP_STUDIO_TAG}")&fq=productVersion:("${currentProduct.label}")`
                break;
              case FUSION_CONNECTORS_TAG:
                searchUrl += `&fq=productName:("${currentProduct.tag}","${FUSION_TAG}","${FUSION_SERVER_TAG}","${FUSION_AI_TAG}")`
                break;
              default:
                break;
            }
          } else {
            searchUrl = defaultSearchParams.fusionSearchUrl + searchParams;
          }
          const config = {
            headers: {
              'Authorization': `Basic ${process.env.GATSBY_FUSION_SEARCH_CREDENTIALS}`,
              'Content-Type': 'application/json',
            }, 
          }

          return axios.get(searchUrl, config).then((response) => response.data).catch(error => {
            console.log(error); // eslint-disable-line no-console
          })
        },
        {
          enabled: !!searchParams,
          refetchOnWindowFocus: false
        }
     )
 }

